export default "__VITE_ASSET__DioINSqZ__"